// extracted by mini-css-extract-plugin
module.exports = {"informContainer":"inform_informContainer__l1bhQ","inner":"inform_inner__3v9tN","informTitle":"inform_informTitle__2KMJj"};